var espresso = document.querySelector('.espresso');
var filter = document.querySelector('.filter');
var espressoColumns = document.querySelector('.espresso-columns');
var filterColumns = document.querySelector('.filter-columns');
var directionsCafe = document.querySelector('.the-cafe ul li:nth-child(2)');
var directionsCoffee = document.querySelector('.coffee-school ul li:nth-child(2)');

if(directionsCafe !== null){
  directionsCafe.addEventListener("click", function(){
    let a= document.createElement('a');
    a.target= '_blank';
    a.href= 'https://goo.gl/maps/rVjQQipGqzuAx6rAA';
    a.click();
  });
}

if(directionsCoffee !== null){
  directionsCoffee.addEventListener("click", function(){
    let a= document.createElement('a');
    a.target= '_blank';
    a.href= 'https://goo.gl/maps/DRxv8ptVzFtSTR436';
    a.click();
  });
}

if(espresso !== null){
  espresso.addEventListener("click", function(){
    espresso.classList.add('active');
    filter.classList.remove('active');
    espressoColumns.classList.add('active');
    filterColumns.classList.remove('active');
  });
}

if(filter !== null){
  filter.addEventListener("click", function(){
    espresso.classList.remove('active');
    filter.classList.add('active');
    filterColumns.classList.add('active');
    espressoColumns.classList.remove('active');
  });
}

